import { inject, lifecycleHooks } from 'aurelia';

export class CurrentRoute {
  name = null;
  params = {};
  data = {};
}

@lifecycleHooks()
@inject(CurrentRoute)
export class TrackCurrentRoute {
  constructor(currentRoute) {
    this.currentRoute = currentRoute;
  }

  loading(viewModel, params, next) {
    this.currentRoute.name = next.data.name ?? null;
    this.currentRoute.params = { customer: next.params.shortName, ...next.params };
    this.currentRoute.data = next.data;
  }
}
